'use client'

import { Cell, Icon, Spacer, Text, type IconType } from '@vinted/web-ui'
import { AngryFace16, Envelope16, Member16, Comment16 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import { PersonalInformationSharingContentType } from '../../constants/personal-information-sharing'

type Props = {
  contentType: PersonalInformationSharingContentType | null
}

const PersonalInformationSharingWarning = ({ contentType }: Props) => {
  const translate = useTranslate('conversation.personal_information_sharing_dialog')

  const warningItems = [
    {
      iconType: AngryFace16,
      text: translate('warnings.identity_theft'),
    },
    {
      iconType:
        contentType === PersonalInformationSharingContentType.Email ? Envelope16 : Comment16,
      text:
        contentType === PersonalInformationSharingContentType.Email
          ? translate('warnings.send_harmful_links')
          : translate('warnings.text_harmful_links'),
    },
    {
      iconType: Member16,
      text: translate('warnings.account_hacked'),
    },
  ]

  const renderWarningBannerItem = ({ iconType, text }: { iconType: IconType; text: string }) => (
    <Cell
      key={text}
      prefix={<Icon name={iconType} display="block" />}
      body={<Text as="p" type="subtitle" text={text} theme="amplified" width="parent" />}
      theme="transparent"
      styling="tight"
    />
  )

  return (
    <div className="personal-information-sharing-modal__warning-banner">
      <Cell theme="transparent">
        <SeparatedList separator={<Spacer />}>
          {warningItems.map(renderWarningBannerItem)}
        </SeparatedList>
      </Cell>
    </div>
  )
}

export default PersonalInformationSharingWarning
